export function useDomain() {
    let host = ''

    if (import.meta.server) {
        const headers = useRequestHeaders();
        host = headers['host'] || '';
    }

    if (import.meta.client) {
        host = window.location.host;
    }

    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const getRootDomain = (hostname: string) => {
        if (domainRegex.test(hostname)) {
            const parts = hostname.split('.')
            return parts.slice(-2).join('.')
        }

        return 'localhost';
    };

    return getRootDomain(host);
}